import React from 'react';
import { Button } from '../../ui/Button';
import { CheckCircle2, Pencil } from 'lucide-react';
interface PersonalInfoData {
  firstName: string;
  lastName: string;
  address: string;
  city: string;
  zipCode: string;
  nationalId: string;
  isPoliticallyExposed: string;
}
interface PersonalInfoReviewProps {
  data: PersonalInfoData;
  onConfirm: () => void;
  onBack: () => void;
  onEdit: (step: number) => void;
}
export function PersonalInfoReview({
  data,
  onConfirm,
  onBack,
  onEdit
}: PersonalInfoReviewProps) {
  const sections = [{
    title: 'Name',
    step: 0,
    content: `${data.firstName} ${data.lastName}`
  }, {
    title: 'Address',
    step: 1,
    content: <>
          {data.address}
          <br data-id="element-227" />
          {data.city}, {data.zipCode}
        </>
  }, {
    title: 'National ID',
    step: 2,
    content: data.nationalId
  }, {
    title: 'Political Exposure',
    step: 3,
    content: data.isPoliticallyExposed === 'yes' ? 'Yes, I am politically exposed' : 'No, I am not politically exposed'
  }];
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-228">
      <div className="flex-1" data-id="element-229">
        <div className="flex items-center gap-3 mb-2" data-id="element-230">
          <div className="p-2 bg-green-100 rounded-full" data-id="element-231">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-232" />
          </div>
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-233">
            Review your details
          </h2>
        </div>
        <p className="text-gray-500 mb-8 ml-14" data-id="element-234">
          Please ensure all information is correct before proceeding.
        </p>

        <div className="space-y-4" data-id="element-235">
          {sections.map(section => <div key={section.title} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:border-gray-300 transition-colors" data-id="element-236">
              <div className="flex justify-between items-start mb-1" data-id="element-237">
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-238">
                  {section.title}
                </span>
                <button onClick={() => onEdit(section.step)} className="text-gray-400 hover:text-blue-600 transition-colors" aria-label={`Edit ${section.title}`} data-id="element-239">
                  <Pencil className="w-4 h-4" data-id="element-240" />
                </button>
              </div>
              <div className="text-gray-900 font-medium" data-id="element-241">{section.content}</div>
            </div>)}
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-242">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-243">
          Back
        </Button>
        <Button variant="primary" onClick={onConfirm} className="w-2/3" data-id="element-244">
          Confirm & Save
        </Button>
      </div>
    </div>;
}